// FNP-861 made this read-only; FNP-969 adds mutations.ts with a DELETE only (the
// module stays append-only — no edit, ever). See that file for why.
//
// Every field below is on the testing-api TestObservation type. `dependedOn` is
// requested on the LIST query as well as the detail query: the cascade grouping in
// useTestObservations needs it for every row, not just the one being inspected.
//
// FNP-969 adds `testDefinitionId` and `testRunIds`, which FNP-966 put on the type
// but this query never selected. `testRunIds` is a LIST, not a scalar: browser
// session state is WAKE-scoped, so one execution of an action is attributed to
// EVERY run that requested it. Rendering it as a single id would misreport a
// shared observation as belonging to one run.
const OBSERVATION_FIELDS = `
    id
    syntheticUserId
    actionCode
    outcome
    error
    durationMs
    verificationResult
    dependedOn
    testDefinitionId
    testRunIds
    observedAt
    createdByUsername
    created
`;

export const listTestObservations = `
   query listTestObservations($filter: TestObservationsFilterInput, $limit: Int, $nextToken: String) {
       listTestObservations(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {${OBSERVATION_FIELDS}}
           nextToken
       }
   }
`;

export const getTestObservation = `
   query getTestObservation($id: ID!) {
       getTestObservation(id: $id) {${OBSERVATION_FIELDS}}
   }
`;

// Backed by the synthetic-user-observed-index GSI — this is the query that makes
// "show me everything this synthetic user did" cheap. Never filter the full list
// client-side to answer that question.
export const listTestObservationsBySyntheticUser = `
   query listTestObservationsBySyntheticUser($syntheticUserId: ID!, $limit: Int, $nextToken: String) {
       listTestObservationsBySyntheticUser(syntheticUserId: $syntheticUserId, limit: $limit, nextToken: $nextToken) {
           items {${OBSERVATION_FIELDS}}
           nextToken
       }
   }
`;
